module.exports = __webpack_public_path__ + "img/img-creditcard.0acd2605.jpg";